<template>
  <v-layout
    row
    align-start
    justify-space-between
    class="mx-3"
    style="position: relative; flex-wrap: nowrap"
    :style="{
      maxHeight: 16 * gridUnitSize + 'px'
    }"
    id="manhole-mask-tab"
  >
    <v-flex xs1 class="mr-3">
      <mask-management />
    </v-flex>

    <v-flex xs8 class="mr-3" style="max-height: inherit">
      <mask-grid :key="$store.getters.getSelectedMaskIndex" />
    </v-flex>

    <v-flex
      xs4
      :style="{
        height: 16 * gridUnitSize + 'px'
      }"
    >
      <mask-toolbar v-if="activeSideSection === 'toolbar'" />
      <duct-entries-selector
        v-else-if="activeSideSection === 'ductEntryTypeSelector'"
      />
      <duct-entry-form v-else-if="activeSideSection === 'ductEntryForm'" />
      <duct-entry-action v-else-if="activeSideSection === 'ductEntryAction'" />
      <mask-mirror v-else-if="activeSideSection === 'maskMirror'" />
      <mask-resize v-else-if="activeSideSection === 'maskResize'" />
    </v-flex>
    <loading-spinner
      :active.sync="loading"
      :is-full-page="false"
      color="accent"
    />
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import LoadingSpinner from "vue-loading-overlay";
import MaskGrid from "./MaskGrid";
import MaskManagement from "./MaskManagement";
import MaskResize from "./MaskResize";
import MaskMirror from "./MaskMirror";
import DuctEntryAction from "../Duct/DuctEntryAction";
import DuctEntryForm from "../Duct/DuctEntryForm";
import DuctEntriesSelector from "../Duct/DuctEntriesSelector";
import MaskToolbar from "./MaskToolbar";
import { ductEntryTypesMixin } from "@/mixins/forms/masks/ductEntryTypesMixin";
export default {
  name: "MasksTab",

  components: {
    MaskManagement,
    MaskGrid,
    MaskResize,
    MaskMirror,
    DuctEntryAction,
    DuctEntryForm,
    DuctEntriesSelector,
    MaskToolbar,
    LoadingSpinner
  },

  mixins: [ductEntryTypesMixin],

  props: {
    originalMasks: {
      type: String | Array,
      required: true
    }
  },

  computed: {
    gridUnitSize() {
      return this.$store.getters.getMaskGridUnitSize;
    },
    activeSideSection() {
      return this.$store.getters.getMasksTabSideSection;
    },
    loading() {
      return this.$store.getters.isMasksTabLoading;
    }
  },

  mounted() {
    this.setMasksTabLoading(true);
    this.storeMasks(this.originalMasks);
  },

  created() {
    this.getDuctEntryTypes();
  },

  methods: {
    ...mapActions([
      "setMasksTabSideSection",
      "setManholeMasks",
      "setMasksTabLoading"
    ]),

    storeMasks(originalMasks) {
      if (originalMasks) {
        if (typeof originalMasks === "string") {
          this.setManholeMasks(JSON.parse(originalMasks));
        } else if (typeof originalMasks === "object") {
          let masks = Array.from(originalMasks);
          this.setManholeMasks(masks);
        }
      }
    }
  },

  watch: {
    originalMasks(newSetOfMasks) {
      this.storeMasks(newSetOfMasks);
    }
  },

  destroyed() {
    this.setMasksTabSideSection("toolbar");
  }
};
</script>

<style>
#manhole-mask-tab .form-input-select .vue-treeselect__control,
#manhole-mask-tab input[type="text"],
#manhole-mask-tab input[type="number"] {
  border-bottom: 1px solid #808080;
}

#manhole-mask-tab #mask-toolbar .v-btn__content {
  justify-content: start;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MasksTab.vue